export const PADDING_BY_SIZE = {
  xs: { topBottom: "2px", leftRight: "8px" },
  sm: { topBottom: "2px", leftRight: "8px" },
  md: { topBottom: "3.5px", leftRight: "8.5px" },
  lg: { topBottom: "3.5px", leftRight: "8.5px" },
  xl: { topBottom: "4px", leftRight: "9px" }
};
const INVERT_MODE = {
  dark: "light",
  light: "dark"
};
const baseColorByStyle = (theme) => ({
  info: theme.colors.variant[INVERT_MODE[theme.mode]].info,
  success: theme.colors.variant[INVERT_MODE[theme.mode]].success,
  warning: theme.colors.variant[INVERT_MODE[theme.mode]].warning,
  danger: theme.colors.variant[INVERT_MODE[theme.mode]].danger
});
export const getBGColorByVariant = (theme, variant, solid = false) => {
  const colorMap = {
    ...baseColorByStyle(theme),
    default: theme.colors.background.secondaryNav
  };
  return `${colorMap[variant]}${variant === "default" ? "ff" : solid ? "" : "25"}`;
};
export const getTextColorByVariant = (theme, style, solid = false) => {
  if (solid) return theme.colors.button[style].color;
  const colorMap = {
    ...baseColorByStyle(theme),
    default: theme.colors.text.primary
  };
  return colorMap[style];
};
